/**
 * RTK Query の createApi 基盤定義
 *
 * 【このファイルの役割】
 * アプリ全体で 1 つだけ存在する RTK Query の「本体」。
 * すべての API エンドポイントはここに集約される。
 *
 * 【なぜ endpoints が空なのか？】
 * RTK Query には「コード分割（Code Splitting）」の仕組みがある。
 * endpoints をここで全部定義するのではなく、
 * 各機能ファイル（authApi.ts, shiftApi.ts 等）から
 * `api.injectEndpoints()` で後から追加する。
 * → ファイルが分かれて管理しやすい。
 *
 * 【tagTypes とは？】
 * キャッシュの「分類タグ」。RTK Query はレスポンスをキャッシュするが、
 * データが変更されたときに関連するキャッシュだけを無効化するために使う。
 *
 * 例：
 * - シフトを作成（mutation） → invalidatesTags: ['Shifts']
 * - シフト一覧（query）     → providesTags: ['Shifts']
 * → シフト作成後に一覧が自動で再取得される
 */

import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../api/baseQuery';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Auth', 'Shifts', 'Staff', 'Notifications', 'Tasks', 'Tenant', 'OperationLogs'],
  endpoints: () => ({}),
});
